var default_styles_default = {
  "button_container": "qA28k",
  "button_margin": "E0qbC",
  "button_text": "tUlvB",
  "button_size_content": "vM2qN"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
